<div *ngIf="showScroller" (click)="gotoTop()" class="scroll-to-top">
  <i class="fas fa-angle-up"></i>
</div>
